export enum OpenBillStatusEnum {
	OVERDUE = 'Em atraso',
	OPEN = 'Em aberto',
	OPEN_STATUS = 'EM ABERTO',
}

export type OpenBillStatus = OpenBillStatusEnum.OVERDUE | OpenBillStatusEnum.OPEN;

export interface BillingBeneficiary {
	nome: string;
	mensalidade: number;
	coparticipacao: number;
	isTitular?: boolean;
}

export interface OpenBillRow {
	cdObrigacao: string;
	cdEspecieTitulo: number;
	status: OpenBillStatus;
	vlObrigacao: number;
	vlAtualizado: number;
	dtVencimento: string;
	dtPrevista: string;
	competencia?: string;
	coparticipacao?: BillingBeneficiary[];
	baseYear?: number;
	numeroContrato?: number;
	beneficiarios?: number;
	cdDocumentoGerador?: string;
	digitableLine?: string;
	isSaoLucas?: boolean;
	downloadLink?: string;
	extraParams?: {
		interestAmount: string | number;
		fineAmount: string | number;
		discountAmount: string | number;
	};
}

export interface OpenBillsTableProps {
	rows: OpenBillRow[];
	selectedIds?: Set<string>;
	onSelectionChange?: (selectedIds: Set<string>) => void;
	onViewDetails?: (row: OpenBillRow) => void;
}
